import { clevertapEvent } from 'utils/clevertap';

export enum PAGE_SOURCE {
  streamPost = 'Stream Post',
  streamLikeList = 'Stream Like List',
  companyPage = 'Company Page',
  chat = 'Chat',
  search = 'Search',
  discoverPeople = 'Discover People',
  followers = 'Followers',
  following = 'Following',
}

export const PAGE_SOURCE_INDEX = [
  'Stream Post',
  'Stream Like List',
  'Company Page',
  'Chat',
  'Search',
  'Discover People',
  'Followers',
  'Following',
  'My Profile',
  'Group Chat Bottom Sheet',
] as const;

export const mainProfileEvents = {
  onViewProfile: (pageSource: PAGE_SOURCE) => {
    clevertapEvent('Stream View Profile', {
      'Page Source': pageSource,
    });
  },
  onUserProfileViewed: (pageSource: PAGE_SOURCE) => {
    clevertapEvent('User Profile Viewed', {
      'Page Source': pageSource,
    });
  },
  onUserProfileChatSelected: () => {
    clevertapEvent('User Profile Chat Selected');
  },
  onUserProfileFollowSelected: () => {
    clevertapEvent('User Profile Follow Selected');
  },
  onUserProfileUnfollowSelected: () => {
    clevertapEvent('User Profile Unfollow Selected');
  },
  onUserProfileTurnOnAlert: () => {
    clevertapEvent('User Profile Turn On Alert');
  },
  onUserProfileComposePost: () => {
    clevertapEvent('User Profile Compose Post');
  },
  onUserProfileAddorRemovefromWatchlist: () => {
    clevertapEvent('User Profile Add or Remove from Watchlist');
  },
  onUserProfileBlock: () => {
    clevertapEvent('User Profile Block');
  },
  onUserProfileSuccessfullyTurnOnAlert: () => {
    clevertapEvent('User Profile Successfully Turn on alert');
  },
  onComposePostViewed: () => {
    clevertapEvent('Compose Post Viewed');
  },
  onUserProfileAddOrRemoveFromWatchlistViewed: () => {
    clevertapEvent('User Profile Add or Remove from Watchlist Viewed');
  },
  onUserProfileBlockConfirmed: () => {
    clevertapEvent('User Profile Block Confirmed');
  },
  onUserProfileSuccessfullyBlocked: () => {
    clevertapEvent('User Profile Successfully Blocked');
  },
  onUserProfileTurnOffAlert: () => {
    clevertapEvent('User Profile Turn Off Alert');
  },
  onUserProfileSuccessfullyTurnOffAlert: () => {
    clevertapEvent('User Profile Successfully Turn Off Alert');
  },
  onUserProfileUnblock: () => {
    clevertapEvent('User Profile Unblock');
  },
  onUserProfileUnblockConfirmed: () => {
    clevertapEvent('User Profile Unblock Confirmed');
  },
  onUserProfileSuccessfullyUnblocked: () => {
    clevertapEvent('User Profile Successfully Unblock');
  },
};
